//
//
//
//
//
//
//
//

import Model from '../../components/model'
import { deepClone } from '@/utils/commonUtils'
import  Button  from './button'

  export default {
    data() {
      return {
        phone:0,
        modules:[],
        code:''
      }
    },
    components: {
      Model,
      Button
    },
    props: {
      allData:{
        type:[Array,Object],
        default(){
          return {
            materielMap:[]
          }
        }
      },
    },
    computed:{
      codeMoudles(){
        return [
            {
              elements:[
                {
                  componentTypeCode: "WBK001",
                  elementCode: 'ZDY001',
                  elementEnums: "ZDY001",
                  elementName:'验证码',
                  pageDetail: '{"defaultHint":"请输入验证码","writeLimit":8,"inputLimit":[]}',
                  showName: '验证码',
                  rightChildren:{
                      component:Button,  //文本框右侧传入button组件 
                      props:{
                        phone:this.phone   //给button组件传入的值
                      }
                  }
                }
              ]
            }
          ]
      }
    },
    watch: {
      allData:{ //分享
        handler(newVal, oldVal) {
        
        const _this = this;
        // const zdyArr = [
        //     {
        //       componentTypeCode: "WBK001",
        //       elementCode: 'ZDY001',
        //       elementEnums: "ZDY001",
        //       elementName:'验证码',
        //       pageDetail: '{"defaultHint":"请输入验证码","writeLimit":8,"inputLimit":[]}',
        //       showName: '验证码',
        //       rightChildren:{
        //           component:Button,  //文本框右侧传入button组件 
        //           props:{
        //             phone:_this.phone   //给button组件传入的值
        //           }
        //       }
        //     }
        //   ]
          // 合并到 modules里 在页面中遍历展示
          let newModules = deepClone( this.allData.modules )
          // newModules[0].elements = this.allData.modules[0].elements.concat(zdyArr)
          this.modules = newModules;
          console.log('allData修改加工modules 传入子组件11111111111')
          
      
      },
        deep: true
      },
      
    },
    methods: {
      // 输入框失去焦点时
        itemChange(item){
            // 如果是验证码输入框
            // if(item.elementCode == "ZDY001"){
            //     if(!(item.value)){
            //       this.$toast('请输入验证码')
            //     }if(!this.phone){
            //       this.$toast('请输入手机号')
            //     }else{
            //          this.STATISTICS_CONFIG.insur_register_code_click()
            //         if( item.value.length === 6){
            //           // 去登陆
            //           console.log('去登陆',item)
            //           const phone = parseInt(this.phone)
            //           loginIn({phone:this.phone,code:item.value})
            //         }else{
            //           this.$toast('验证码格式不正确')
            //         }
            //     }
                
            // }
        },
        // 
        changeData({allFromData,fromPageData}){
          console.log('change',{allFromData,fromPageData})
          let phone = this.phone = fromPageData.BUYER_MOBILE.value
          this.$emit('change',{fromPageData,phone})
        },
        changeCodeData({allFromData,fromPageData}){
           this.code = allFromData.ZDY001.value;
           this.$emit('changeCode',this.code)
        }
    },
        
  }
